import { render } from "./VoMaxFormulario.vue?vue&type=template&id=3ba7b7c3&scoped=true"
import script from "./VoMaxFormulario.vue?vue&type=script&lang=js"
export * from "./VoMaxFormulario.vue?vue&type=script&lang=js"

import "./VoMaxFormulario.vue?vue&type=style&index=0&id=3ba7b7c3&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ba7b7c3"]])

export default __exports__